import { AlertLogConfig } from "services/session-token";
import { shouldNotifyCandidate } from "helpers/notify-candidate";
import { setNotificationAlerts, setRecordingStartedTimestamp } from "store/app.slice";
import { AlertDisplayType, AlertName, AlertType } from "helpers/alert-type";
import { enqueueItem } from "store/alertSlice";
import { getSystemTime } from "./common";
import { monitoringAlertsToNotifyCandidate } from "config/constant";
import { restrictedTriggerAlertTypeIds } from "helpers/proctor-client-trigger-helper";

const fireEventHandlersDirect = (eventNames: string, data: any) => {
  eventNames.split(" ").forEach((eventName) => {
    const handlers = window.ProctorClient3.eventHandlers?.[eventName];
    if (handlers) {
      handlers.forEach((handler: any) => handler(data));
    }
  });
};

type ExtensionAlertPayload = {
  extend_time: number;
  extend_reason: string;
};

type AlertPayload = string | ExtensionAlertPayload;

const getExtensionPayload = (payload?: AlertPayload | null): ExtensionAlertPayload | undefined => {
  if (!payload) return undefined;

  let parsedPayload: Partial<ExtensionAlertPayload>;
  try {
    parsedPayload = typeof payload === "string" ? JSON.parse(payload) : payload;
  } catch {
    return undefined;
  }
  if (
    typeof parsedPayload?.extend_time !== "number" ||
    typeof parsedPayload?.extend_reason !== "string"
  ) {
    return undefined;
  }

  return {
    extend_time: parsedPayload.extend_time,
    extend_reason: parsedPayload.extend_reason
  };
};

export const alertHelper = (alertConfig: AlertLogConfig[]) => {
  const getAlert = (alert: AlertName, payload?: AlertPayload | null, description?: string | null) => {
    const alertTypeId = AlertType[alert].id;
    const isExtensionAlert = alertTypeId === AlertType[AlertName.ProctoringSessionExtended].id;

    return {
      alert_type_id: alertTypeId,
      description: description ? description : AlertType[alert].alertName,
      timestamp: getSystemTime().toISOString(),
      payload: isExtensionAlert
        ? getExtensionPayload(payload)
        : typeof payload === "string"
          ? { file: payload }
          : undefined
    };
  };
  const raiseAlert = (
    alert: AlertName,
    dispatch: any,
    description?: string | null,
    payload?: AlertPayload | null,
    skipUpload?: boolean
  ) => {
    const alertData = getAlert(alert, payload, description);
    if (alert === AlertName.RecordingStarted) {
      dispatch(setRecordingStartedTimestamp({ recordingStartedTimestamp: alertData.timestamp }));
    }
    const eventNames = `log:event:all log:event:type:${alertData.alert_type_id}`;
    if (restrictedTriggerAlertTypeIds.has(alertData.alert_type_id)) {
      fireEventHandlersDirect(eventNames, alertData);
    } else {
      window.ProctorClient3.trigger(eventNames, alertData);
    }

    if (!skipUpload) {
      dispatch(enqueueItem(alertData));
    }

    if (
      AlertType[alert].displayType !== AlertDisplayType.None &&
      shouldNotifyCandidate(alertConfig, AlertType[alert].id)
    ) {
      if (monitoringAlertsToNotifyCandidate.includes(AlertType[alert].id)) {
        const alertData = {
          ...AlertType[alert],
          description
        };
        dispatch(setNotificationAlerts(alertData));
      } else {
        dispatch(setNotificationAlerts(AlertType[alert]));
      }
    }
  };
  return { raiseAlert, getAlert };
};
